<template>
  <div class="orderGoods">
    <div class="total">
        <div style="position: relative;">
            共{{ cartInfo.length }}件商品
            <div style="position: absolute; top: 0px; right: 10px; color:blue;" @click="showList">{{btn_text}}</div>
        </div>
    </div>
    <div class="goodWrapper" v-show="show_list">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
        style="height:auto;padding-top:7px; padding-bottom:7px;"
      >
        <div class="text" style="width:auto;">
          <div class="acea-row row-between-wrapper">
            <div class="name line1" style="overflow:auto;text-overflow:auto;white-space:normal;width:auto;">{{ cart.productInfo.store_name }}</div>
          </div>
          <div class="attr line1" style="overflow:auto;text-overflow:auto;white-space:normal;width:auto;" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          
          <div class="money font-color-red">￥{{ cart.productInfo.ot_price }} x {{ cart.cart_num }}</div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoodsCaigou",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    payType: String
  },
  data: function() {
    return {
        show_list: false,
        btn_text: "显示书目详情"
    };
  },
  mounted: function() {},
  methods: {
    showList() {
        this.show_list = !this.show_list;
        if(!this.show_list)
            this.btn_text = "显示书目详情";
        else
            this.btn_text = "隐藏书目详情";
    }
  }
};
</script>
